'use strict';

/**
 * CookieConsentDialog
 *
 * @author Srdan Turudic <srdan.turudic@namics.com>
 */
T.Module.CookieConsentDialog = T.createModule({

	_stateClasses: {
		cookieDialogVisible: 'state-m-cookie-consent-dialog--visible'
	},

	start: function start(resolve) {
		this.neededCookieCategory = 'C0004';

		this.$ctx = $(this._ctx);

		this.initializeOneTrust();

		resolve();
	},


	/**
  * custom event being dispatched in the page layouts one trust snippet
  *
  * @returns {void}
  */
	initializeOneTrust: function initializeOneTrust() {
		var _this = this;

		this.$ctx.onclick = this.onCookieNoticeClick.bind(this);

		window.addEventListener('onetrust.init', function () {
			_this.checkCookieNoticeVisibility();

			// eslint-disable-next-line new-cap
			window.Optanon.OnConsentChanged(function () {
				_this.checkCookieNoticeVisibility();
			});
		});
	},
	onCookieNoticeClick: function onCookieNoticeClick(evt) {
		evt.preventDefault();

		if (!window.Optanon || !(typeof window.Optanon.ToggleInfoDisplay === 'function')) {
			return false;
		}

		// eslint-disable-next-line new-cap
		window.Optanon.ToggleInfoDisplay();
	},
	getCookieNoticeState: function getCookieNoticeState() {
		var state = false;

		if (!window.Optanon) {
			state = false;
		}

		var allowedCookies = window.OptanonActiveGroups || '';
		var allowedCookiesArray = allowedCookies.split(',');

		if (allowedCookiesArray.indexOf(this.neededCookieCategory) >= 0) {
			state = false;
		} else {
			state = true;
		}

		return state;
	},
	checkCookieNoticeVisibility: function checkCookieNoticeVisibility() {
		var showCookieNotice = this.getCookieNoticeState();

		if (showCookieNotice) {
			this.$ctx.addClass(this._stateClasses.cookieDialogVisible);
		} else {
			this.$ctx.removeClass(this._stateClasses.cookieDialogVisible);
		}
	}
});